import React from "react";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/styles";
import theme from "./theme";

import { SnackbarProvider } from "notistack";
import { ConfirmProvider } from "material-ui-confirm";

import "../variables.scss";
import "../index.scss";

const ThemeProvider: React.FC = ({ children }) => {
  return (
    <MuiThemeProvider theme={theme}>
      <SnackbarProvider
        autoHideDuration={3000}
        preventDuplicate
        maxSnack={3}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <ConfirmProvider>{children}</ConfirmProvider>
      </SnackbarProvider>
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
